import React from "react";
import "./ProvidersStyle.scss";
import { providersTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";
import useEmblaCarousel from "embla-carousel-react";
import AutoScroll from "embla-carousel-auto-scroll";

const ProvidersSection = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      slidesToScroll: "auto",
      align: "start",
      loop: true,
    },
    [AutoScroll({ playOnInit: true, stopOnInteraction: false, speed: 1.5, startDelay: 0 })]
  );

  return (
    <section className="providers-section">
      <div className="providers-wrap">
        {/* <SectionHeading>{providersTextContent.headingText}</SectionHeading> */}

        <div className="embla">
          <div className="embla__viewport" ref={emblaRef}>
            {providersTextContent.providersContent.map((provider, index) => (
              <div className="embla__container" key={index}>
                {provider.imageContent.map((image, imgIndex) => (
                  <div className="embla__slide">
                    <div className="logo-img-box">
                      <img
                        src={image.imageSrc}
                        key={imgIndex}
                        alt={`Provider Logo ${imgIndex + 1}`}
                      />
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProvidersSection;
